import ContentLoader from 'react-content-loader';
import styled, { useTheme } from 'styled-components';
import WidthContainer from '../../../components/WidthContainer';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive';

const ClaimGiftContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  gap: 20px;
  z-index: 1;

  @media ${PHONE_MEDIA_QUERY} {
    margin-top: 30px;
    gap: 16px;
  }
`;

const GiftContainer = styled.div`
  width: 100%;
  max-width: 516px;
  position: relative;
  margin-bottom: 50px;
  overflow: visible;

  @media ${PHONE_MEDIA_QUERY} {
    margin-bottom: 30px;
  }
`;

const CardDetailRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  max-width: 516px;

  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
  }
`;

const GiftCardSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width='100%'
      height={286}
      viewBox='0 0 516 286'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='15' ry='15' width='100%' height='286' />
    </ContentLoader>
  );
};

const TitleSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={300}
      height={30}
      viewBox='0 0 300 30'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='4' ry='4' width='300' height='30' />
    </ContentLoader>
  );
};

const PriceSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={250}
      height={24}
      viewBox='0 0 250 24'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='4' ry='4' width='250' height='24' />
    </ContentLoader>
  );
};

const DetailRowSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width='100%'
      height={24}
      viewBox='0 0 516 24'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='4' ry='4' width='100' height='24' />
      <rect x='416' y='0' rx='4' ry='4' width='100' height='24' />
    </ContentLoader>
  );
};

const MessageSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width='100%'
      height={80}
      viewBox='0 0 516 80'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='4' ry='4' width='100' height='24' />
      <rect x='0' y='40' rx='4' ry='4' width='100%' height='40' />
    </ContentLoader>
  );
};

const ButtonSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={150}
      height={40}
      viewBox='0 0 150 40'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='8' ry='8' width='150' height='40' />
    </ContentLoader>
  );
};

const ClaimGiftSkeleton = () => {
  return (
    <WidthContainer>
      <ClaimGiftContainer>
        <GiftContainer>
          <GiftCardSkeleton />
        </GiftContainer>
        <TitleSkeleton />
        <PriceSkeleton />
        <CardDetailRow>
          <DetailRowSkeleton />
        </CardDetailRow>
        <div style={{ width: '100%', maxWidth: '516px' }}>
          <MessageSkeleton />
        </div>
        <ButtonSkeleton />
      </ClaimGiftContainer>
    </WidthContainer>
  );
};

export default ClaimGiftSkeleton;
